import { useState, useEffect, useCallback } from "react";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import api from "@/lib/api";

export function NotificationsBell() {
  const [data, setData] = useState({ unread: 0, notifications: [] });

  const load = useCallback(async () => {
    try { const { data } = await api.get("/notifications"); setData(data); } catch {}
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, [load]);

  const onOpen = async (o) => {
    if (o && data.unread > 0) {
      try { await api.post("/notifications/read"); setData((d) => ({ ...d, unread: 0 })); } catch {}
    }
  };

  return (
    <Popover onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <button className="relative p-2 text-zinc-300 hover:text-white" data-testid="notifications-bell" aria-label="Notifications">
          <Bell className="w-5 h-5" />
          {data.unread > 0 && <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#E53E3E] text-white text-[10px] font-bold grid place-items-center" data-testid="notifications-unread">{data.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 bg-zinc-900 border-zinc-800 max-h-96 overflow-y-auto">
        <div className="p-3 border-b border-zinc-800"><p className="font-display font-bold uppercase text-sm tracking-tight">Notifications</p></div>
        {data.notifications.length === 0 ? (
          <p className="p-4 text-sm text-zinc-500">No notifications yet.</p>
        ) : data.notifications.map((n) => (
          <div key={n.id} className={`px-4 py-3 border-b border-zinc-800/60 text-sm ${n.read ? "text-zinc-400" : "text-white"}`} data-testid="notification-item">
            <p>{n.text}</p>
            <p className="text-[11px] text-zinc-600 mt-0.5">{new Date(n.created_at).toLocaleString()}</p>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
}
